"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReservationOverviewInfoTotal = void 0;
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
require("./index.scss");
const ReservationOverviewInfoTotal = (props) => {
    const { className, price } = props;
    const classNames = (0, classnames_1.default)('reservation-overview-info-total', className);
    return (react_1.default.createElement("div", { className: classNames },
        react_1.default.createElement("p", { className: 'reservation-overview-info-total__title' },
            react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/StepReservationOverview/ReservationOverviewInfo:totalPrice', defaultMessage: 'Total price' })),
        react_1.default.createElement("p", { className: 'reservation-overview-info-total__info' },
            react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/StepReservationOverview/ReservationOverviewInfo:info', defaultMessage: '(excl. 1.5% payment fee)' })),
        react_1.default.createElement("p", { className: 'reservation-overview-info-total__price' },
            "CHF ",
            price)));
};
exports.ReservationOverviewInfoTotal = ReservationOverviewInfoTotal;
//# sourceMappingURL=index.js.map